import axios from 'axios';

export const API = async (url, requestBody = {}, token = null, type = null) => {

    // console.log(url, "Passwordurl")
    // console.log(requestBody, "passwordBody")
    try {
        const headers = {
            'Content-Type': type ? type : 'application/x-www-form-urlencoded',
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        // console.log(url, "Passwordurl22")
        // console.log(requestBody, "passwordBody22")
        // // console.log(token, "token22")
        // console.log(headers, "headers")
        
        const response = await axios.post(url, requestBody, { headers });
        // console.log(response, "response")

        return response.data;
    } catch (error) {
        console.error('Error verifying email:', error);
        throw error;
    }
};
